import React from "react";
import {
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";

import { API } from "../../../../../shared/services";
import { ContainerSpotlight } from "./styles";
import { ItemSpotlight } from "../Item";
import { Formik } from "formik";

import moment from "moment-timezone";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { useContacts, useMainState } from "../../../contexts";
import * as RailsTimeZone from "rails-timezone";

export default function CurrentActivitySpotlight({ customer }) {
  const { updateCurrentContact } = useContacts();
  const { setSpotlight } = useContacts();
  const { company } = useMainState();
  const { t } = useTranslation("Customer");

  const currentTime = moment()
    .tz(RailsTimeZone.from(company.timezone))
    .locale(company.locale);

  const defaultDate = moment(currentTime)
    .add(1, "day")
    .hours(9)
    .minutes(0)
    .seconds(0);

  function onKeyDown(keyEvent) {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault();
    }
  }

  return (
    <ItemSpotlight title={"Agendar atividade"}>
      <ContainerSpotlight noValidate autoComplete="off">
        <Formik
          initialValues={{
            activity_type: "feedback_customer",
            notes: "",
            date: defaultDate.format("YYYY-MM-DD"),
            time: defaultDate.format("HH:mm"),
          }}
          onSubmit={async (values) => {
            try {
              const result = await API.post("activities", {
                activity: {
                  activity_type: values.activity_type,
                  customer_id: customer.id,
                  date: moment(`${values.date} ${values.time}`).toDate(),
                  notes: values.notes,
                  status: "open",
                },
              });

              toast.success("Atividade agendada com sucesso");

              updateCurrentContact({
                ...customer,
                last_activity: result.data,
              });

              setSpotlight(null);
            } catch (e) {
              toast.error("Erro ao agendar atividade");
            }
          }}
        >
          {({ values, handleChange, errors, handleSubmit, isSubmitting }) => {
            return (
              <form className="contact-details-sidebar" onKeyDown={onKeyDown}>
                <FormControl
                  className="current-activity-sidebar___input"
                  component="fieldset"
                >
                  <FormLabel component="legend">
                    {t("spotlights.activity.labels.type")}
                  </FormLabel>
                  <RadioGroup
                    aria-label="type"
                    name="activity_type"
                    onChange={handleChange}
                    value={values.activity_type}
                  >
                    <FormControlLabel
                      control={<Radio />}
                      label={t("spotlights.activity.labels.typeCall")}
                      value="feedback_customer"
                    />

                    <FormControlLabel
                      label={t("spotlights.activity.labels.typeVisit")}
                      control={<Radio />}
                      value="scheduled_visit"
                    />
                  </RadioGroup>
                </FormControl>

                <TextField
                  name="date"
                  variant="outlined"
                  label={t("spotlights.activity.labels.date")}
                  type="date"
                  value={values.date}
                  InputProps={{
                    inputProps: { min: currentTime.format("YYYY-MM-DD") },
                  }}
                  onChange={handleChange}
                  className="current-activity-sidebar___input"
                  format="DD/MM/YYYY"
                />

                <TextField
                  name="time"
                  variant="outlined"
                  className="current-activity-sidebar___input"
                  label={t("spotlights.activity.labels.time")}
                  value={values.time}
                  onChange={handleChange}
                  type="time"
                />

                <TextField
                  variant="outlined"
                  className="current-activity-sidebar___input"
                  fullWidth
                  rows="5"
                  name="notes"
                  type="textarea"
                  label="Notas"
                  value={values.notes}
                  onChange={handleChange}
                />
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <CircularProgress />
                  ) : (
                    t("spotlights.activity.action")
                  )}
                </Button>
              </form>
            );
          }}
        </Formik>
      </ContainerSpotlight>
    </ItemSpotlight>
  );
}
